import { Contract, FinancialDetails } from 'cpfr-common';
import { useMyProfile } from 'components/my-profile';
import { DefinitionList, DefinitionListItem } from '@cp-shared-19/frontend-ui';
import { Accordion } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { emptyObjectOrAllValuesAreUndefined } from '../../../../utils';
import { ErrorNotification } from '../../../notifications/error/ErrorNotification';
import { TranslationFormat, useTranslationWithFormatting } from 'localization/useTranslationWithFormatting';
import { IbanSection } from '../financial-details/iban-section';

type ContractPartiesProps = {
    contract?: Contract;
    financialDetails?: FinancialDetails;
    isContactInformationChangePending: boolean;
    setShowSuccessNotification: (val: boolean) => void;
    allowedProductTypes: string[];
};

export const FinancialDetailsOspComponent: React.FC<ContractPartiesProps> = ({
    contract,
    financialDetails,
    isContactInformationChangePending,
    setShowSuccessNotification,
    allowedProductTypes,
}) => {
    const { t, f } = useTranslationWithFormatting('financial-details-osp');
    const { data: myProfileData } = useMyProfile();

    if (
        !financialDetails ||
        !contract ||
        (contract.productType && !allowedProductTypes.includes(contract.productType))
    ) {
        return null;
    }
    const { isActive, contractId } = contract;
    const { firstDatePayment, lastDatePayment, monthlyPaymentTTC } = financialDetails;
    const itemList: DefinitionListItem[] = [];

    const isError = emptyObjectOrAllValuesAreUndefined(financialDetails);

    if (firstDatePayment) {
        itemList.push({
            label: t('general-section.first-date-payment'),
            value: firstDatePayment,
            testId: 'first-date-payment',
        });
    }

    if (lastDatePayment) {
        itemList.push({
            label: t('general-section.last-date-payment'),
            value: lastDatePayment,
            testId: 'last-date-payment',
        });
    }

    if (monthlyPaymentTTC) {
        itemList.push({
            label: t('general-section.monthly-payment-ttc'),
            value: f(monthlyPaymentTTC, TranslationFormat.CURRENCY),
            testId: 'monthly-payment-ttc',
        });
    }

    return (
        <Accordion.Item id={`financial-details-osp-${contractId}`} title={t('title')} titleLevel={4}>
            {isError ? (
                <ErrorNotification testId={'not-found-error'} headline={t('error.headline')} text={t('error.text')} />
            ) : (
                <>
                    <IbanSection
                        details={financialDetails}
                        isActive={isActive}
                        contractId={contractId}
                        userEmail={myProfileData?.contactDetails?.email || ''}
                        isContactInformationChangePending={isContactInformationChangePending}
                        setShowSuccessNotification={setShowSuccessNotification}
                    />
                    <DefinitionList className="u-mt-small" split={true} list={itemList} />
                </>
            )}
        </Accordion.Item>
    );
};
